var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengthTrainingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L17.4352 6.48842C18.578 4.48845 17.1339 2 14.8305 2H9.16954C6.86607 2 5.42197 4.48845 6.56481 6.48842L8 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C7.58172 8 4 11.5817 4 16C4 18.7341 5.3716 21.1479 7.46427 22.5908C7.88358 22.8799 8.39125 23 8.90057 23H15.0994C15.6088 23 16.1164 22.8799 16.5357 22.5908C18.6284 21.1479 20 18.7341 20 16C20 11.5817 16.4183 8 12 8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5357 22.5908L15.9681 21.7676L16.5357 22.5908ZM5 16C5 12.134 8.13401 9 12 9V7C7.02944 7 3 11.0294 3 16H5ZM8.03191 21.7676C6.19837 20.5033 5 18.3915 5 16H3C3 19.0768 4.54484 21.7925 6.89662 23.4141L8.03191 21.7676ZM15.0994 22H8.90057V24H15.0994V22ZM19 16C19 18.3915 17.8016 20.5033 15.9681 21.7676L17.1034 23.4141C19.4552 21.7925 21 19.0768 21 16H19ZM12 9C15.866 9 19 12.134 19 16H21C21 11.0294 16.9706 7 12 7V9ZM15.0994 24C15.7583 24 16.4781 23.8452 17.1034 23.4141L15.9681 21.7676C15.7547 21.9147 15.4592 22 15.0994 22V24ZM6.89662 23.4141C7.52186 23.8452 8.24169 24 8.90057 24V22C8.5408 22 8.2453 21.9147 8.03191 21.7676L6.89662 23.4141Z",
    fill: "currentColor "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthTrainingActive);
export default __webpack_public_path__ + "static/media/strength-training-active.2385bf122cd06e4b59b07143efb8e1ff.svg";
export { ForwardRef as ReactComponent };